module.exports = firebase;


//////////////////
// WEBPACK FOOTER
// external "firebase"
// module id = 677
// module chunks = 0